import {OfferListSubType} from "../../../types/OfferListSubType";

export function getFloorChoiceMetaText(offerListSubFilter: string) {
    switch (offerListSubFilter) {
        case OfferListSubType.FLOOR_GROUND:
            return "parter";
        case OfferListSubType.FLOOR_GROUND_WITH_GARDEN:
            return "parter z ogródkiem";
        case OfferListSubType.LAST_FLOOR:
            return "ostatnie piętro";
        default:
            throw new Error("Invalid floor choice in params (offerListSubFilter)");
    }
}
import {OfferListSubType} from "../../../types/OfferListSubType";

export function getFloorChoiceMetaText(offerListSubFilter: string) {
    switch (offerListSubFilter) {
        case OfferListSubType.FLOOR_GROUND:
            return "parter";
        case OfferListSubType.FLOOR_GROUND_WITH_GARDEN:
            return "parter z ogródkiem";
        case OfferListSubType.LAST_FLOOR:
            return "ostatnie piętro";
        default:
            throw new Error("Invalid floor choice in params (offerListSubFilter)");
    }
}
